export default __webpack_public_path__ + "static/media/mosaic3.6bc8a1eb.png";